import { AnalyticsEventTopic } from '~/modules/analytics/analyticsHelper';
import { AnalyticsEvent } from '~/modules/services/analyticsService';
import { GA4FilterClickEvent, GtmEventType } from './gtmEventType';

export type FilterClickAnalyticsEvent = {
    checked: boolean;
    searchContext: {
        sectionLabel: string;
        keyword: string;
        url: string;
        optionLabel: string;
        searchResults: number;
        searchResultsCountPerType: {
            apps: number;
            consultants: number;
        };
        bucket: string;
    };
} & AnalyticsEvent;

export class GtmFilterClickType extends GtmEventType {
    // @ts-expect-error * Automated Type Error Fix
    canHandle(event): boolean {
        return (
            event.topic === AnalyticsEventTopic.ANALYTICS_CLICK &&
            (event.elementType === 'filter' || event.elementType === 'chip') &&
            !event.sortLabel
        );
    }

    getBody(event: FilterClickAnalyticsEvent): GA4FilterClickEvent {
        const { checked, searchContext } = event;
        const { sectionLabel, keyword, optionLabel, searchResultsCountPerType, bucket } = searchContext;
        const filterAction = checked ? 'add' : 'remove';

        return {
            event: 'custEv_contentClick',
            click_text: optionLabel,
            element_type: 'filter',
            filter_label: sectionLabel,
            filter_action: filterAction,
            search_term: keyword,
            search_type: 'site',
            search_result_count: (searchResultsCountPerType?.apps || 0) + (searchResultsCountPerType?.consultants || 0),
            search_category: bucket || 'all',
            app_results: searchResultsCountPerType?.apps,
            consultant_results: searchResultsCountPerType?.consultants,
        };
    }
}
